import gettext from '@sdk/lang/gettext';
import { FormLabel } from '@sdk/components/ui/modalForm/modalForm.styles';
import TextareaAutoheight from '@sdk/components/forms/TextareaAutoheight';
import { useFormContext } from 'react-hook-form';

import NotesIcon from '@web/assets/svg/UI/notes.svg';

export const DescriptionField = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <FormLabel htmlFor="task-template-description-field">
        {gettext('description')} <NotesIcon aria-hidden={true} />
      </FormLabel>
      <TextareaAutoheight
        {...register('description')}
        maxLength={2048}
        maxRows={6}
        id="task-template-description-field"
        placeholder={gettext('Add a description')}
        invalid={Boolean(errors.description)}
      />
    </>
  );
};
